import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const ADMIN_PATHS = [
    '/payouts',
    '/payout/list',
    '/third-party-orders',
    '/va-extern',
    '/proj-calculation',
    '/fp-report',
    '/project-review',
    '/fg-review-list',
    '/fg_budget_years',
    '/zsl-antrag',
    '/zsl',
    '/zsl-summary',
    '/project-settings',
    '/user-management',
    '/start-page',
    '/sorten',
    '/project-convert',
    '/project-funding',
    '/crop-forecast',
];

function AdminBackLink() {
    const { pathname } = useLocation();
    const isAdminPage = ADMIN_PATHS.some(
        p => pathname === p || pathname.startsWith(p + '/')
    );
    if (!isAdminPage) return null;
    return (
        <div style={{ padding: '16px 0 4px 0', borderBottom: '1px solid #e8e8e8', marginBottom: 8 }}>
            <Link to="/admin" style={{ fontSize: 18, fontWeight: 600, color: '#555' }}>← Administrator</Link>
        </div>
    );
}

export default AdminBackLink;
